import { injectGlobal } from 'emotion';
import { mq } from './utilities';


export default injectGlobal`

    * { box-sizing: border-box }

    html {
        margin: 0;
        ${mq({ marginTop: ['50px', '70px', '70px', '110px'] })};
    }

    body {
        margin: 0;
        min-width: 305px;
        font-family: 'Montserrat', Helvetica, Arial;
        font-weight: 300;
        font-style: normal;
        text-rendering: optimizeLegibility;
    }

    h1, h2, h3, h4, h5, h6 {
        font-weight: 300 !important;
    }

`;



// WEBPACK FOOTER //
// ./src/css/global.js